/** 'smooth', unless the visitor asked for reduced motion. */
export const scrollBehavior = () => (
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
);
